import React from 'react'
import { colors } from '../../styles/tokens'

/**
 * Mensagem de erro
 * 
 * Single Responsibility: Exibir mensagem de erro
 */
export default function ErrorMessage({ error }) {
  if (!error) return null

  return (
    <div style={{
      padding: '1rem 1.5rem',
      backgroundColor: 'rgba(239, 68, 68, 0.1)',
      borderBottom: `1px solid ${colors.border}`
    }}>
      <p style={{ margin: 0, color: '#ef4444' }}>
        ❌ {error}
      </p>
    </div>
  )
}
